import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import CaseStudy from '@src/components/DisposalPage/CaseStudy'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import dumpster from '../../json/dumpster-rental-data.json'

const dumpsterServiceData = {
  name: 'Dumpster Rental Services',
  description:
    'Nationwide roll-off dumpster rental in 3, 5, 10, 20, 30, and 40 yard sizes with flexible rental periods, transparent material pricing, and dumpster swaps for ongoing job sites and businesses.',
  serviceType: 'Dumpster Rental',
  url: 'https://getdimension.com/dumpster-rental',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: '5 Yard Dumpster Rental' },
    { name: '10 Yard Dumpster Rental' },
    { name: '20 Yard Dumpster Rental' },
    { name: '30 Yard Dumpster Rental' },
    { name: '40 Yard Dumpster Rental' },
    { name: 'Dumpster Swaps' },
  ],
}

const dumpsterFAQData = {
  questions: dumpster.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function DumpsterRental() {
  return (
    <>
      <Head>
        <title>Affordable Dumpster Rental Services | Dimension</title>
        <meta
          name="description"
          content="Roll-off dumpster rental nationwide in 5 to 40 yard sizes, from around $300. Flexible rental periods, dumpster swaps, and clear material pricing. Book online in minutes."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/dumpster-rental" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={dumpsterServiceData} />
        <SchemaMarkup type="FAQPage" data={dumpsterFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={dumpster.pitch.heading}
          material={dumpster.pitch.material}
          pitchText={dumpster.pitch.pitchText}
          ctaLink={dumpster.pitch.ctaLink}
          ctaText={dumpster.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...dumpster.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...dumpster.benefits} />
        <CaseStudy {...dumpster.caseStudy} />
        <Approach {...dumpster.approach} />
        <FAQ {...dumpster.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Junk Removal Services',
              href: '/junk-removal',
              description:
                'Full-service pickup when you would rather have a crew load it than fill a container yourself.',
            },
            {
              label: 'Cardboard Recycling',
              href: '/cardboard-recycling',
              description:
                'Dedicated cardboard collection — the zero-surcharge material worth keeping out of your dumpster.',
            },
            {
              label: 'Pallet Disposal',
              href: '/pallet-disposal',
              description:
                'Wood, plastic, and metal pallet recycling at warehouse volume, priced per pallet.',
            },
            {
              label: 'Dumpster Swaps',
              href: '/dumpster-swaps',
              description:
                'Full container out, empty container in — one visit, for sites that fill a roll-off faster than a rental period.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default DumpsterRental
